<template>
  <div class="question-container bg-secondary-3">
    <div
      v-for="(question, questionIndex) in questionsList"
      :key="questionIndex"
      class="question-item row mx-auto col px-0"
    >
      <div
        class="question-box-content row mx-auto col-12 d-flex justify-content-between align-items-end px-0"
      >
        <p class="col px-0 color-gray-6">
          {{ question.description }}
        </p>
        <div class="custom-radio-container d-flex align-items-end px-0"
        :class="{
            'col':!removeColHeader
          }">
          <div
            v-for="(answer, answerIndex) in question.possibleAnswers"
            :id="`rbAnswersContainer-${answerIndex}`"
            :key="answerIndex"
            class="text-center rounded-top mb-0 custom-radio-button"
            :class="{
              'bg-primary-1': question.submittedAnswerTypeId === answer.id,
              'bg-secondary-9': question.submittedAnswerTypeId !== answer.id,
              'bg-red': false
            }"
          >
            <div :id="`radio-answer-${answerIndex}`" class="radio">
              <label
                :id="`lbl-radio-answer-${answerIndex}`"
                class="radio-label w-100 mb-0"
              >
                <input
                  :id="`radio-button-answer-${answerIndex}`"
                  type="radio"
                  :name="`radio-answer-YesNoOption`"
                  :value="question.submittedAnswerTypeId === answer.id"
                  :disabled="isReadonly"
                  @change="updateSelectedAnswer(question.id, answer.id)"
                />
                <span
                  :id="`span-icon-${answerIndex}`"
                  class="cr rounded-circle"
                  :class="{
                    'cr-inactive': question.submittedAnswerTypeId !== answer.id,
                    'cr-active': question.submittedAnswerTypeId === answer.id,
                    'cr-error': false
                  }"
                >
                  <i
                    :id="`answer-icon-${answerIndex}`"
                    class="cr-icon fa fa-check text-white"
                    :class="{
                      'show-check': question.submittedAnswerTypeId === answer.id
                    }"
                  />
                </span>
              </label>
            </div>
            <span
              class="step-label font-12"
              :class="{
                'color-gray-8': question.submittedAnswerTypeId !== answer.id,
                'color-white fw-bold':
                  question.submittedAnswerTypeId === answer.id
              }"
            >
              {{ answer.name }}
            </span>
          </div>
        </div>
      </div>
      <Error
        v-if="validate && question.submittedAnswerTypeId == null"
        :is-alert-mode="false"
        class="mt-0"
        variant="no-border"
        message="Favor de seleccionar Sí o No"
      />
      <div
        v-if="studentHasColonostomy(question)"
        class="question-document bg-secondary-9 rounded col-12 p-0"
      >
        <div
          v-if="question.uploadDocumentPanel"
          class="document-uploader mx-auto row bg-white rounded py-3 px-4"
        >
          <div class="col">
            <label class="field-label">Documento</label>
            <div class="field-value">
              SAEE-10.b Referido médico necesidad servicios de colostomía
            </div>
          </div>
          <div class="col">
            <label class="field-label">Archivo</label>
            <div class="field-value">
              {{ displayDocumentName(question) | empty }}
            </div>
          </div>
          <div class="col d-flex justify-content-end align-items-center">
            <custom-file-input
              id="question-document-upload"
              ref="question-document-upload"
              display-style="normal"
              :accept="'.pdf'"
              :attachment-id="documentAttachmentId(question)"
              :on-download="onDownloadDocument"
              :disabled="!isDraft"
              @input="file => onUploadFile(question.id, file)"
            />
          </div>
           <div class="col" v-if="isDraft">
             <action-button             
              type="button"
              text="Descargar Referido Médico"
              i="fas fa-file-download pr-2"
              variant="outline-success mt-3"
              @click="downloadMedicalReferral()"
            />
          </div>
        </div>
        <BoxIconButton
          v-else
          icon="fas fa-file-plus"
          title="Oprima aquí para añadir documento Referido Médico Anejo 2"
          class="box-icon-button"
          @click="onAddClickHandler(question)"
        />
        <Error
          v-if="
            (displayDocumentName(question) == '' ||
              displayDocumentName(question) == null) &&
              validate
          "
          :is-alert-mode="false"
          class="mt-0"
          variant="no-border"
          message="Favor de adjuntar el Anejo 2: Referido médico validado por la/el enfermera/o escolar."
        />
      </div>
    </div>
    <div class="d-flex justify-content-end">
      <action-button
        v-if="isDraft"
        type="button"
        text="Guardar"
        i="fa fa-save pr-2"
        variant="success"
        @click="onSaveQuestions"
      />
    </div>
  </div>
</template>

<script>
import store from "@/store/index";
import AnswerType from "@/utils/constants/pei/serviceNeedQuestionnaire/answerType";
import needsService from "@/services/pei/serviceNeedQuestionnaire";
import ActionButton from "ActionButton";
import CustomTextArea from "CustomTextArea";
import BoxIconButton from "@/components/pei/shared/BoxIconButton";
import CustomFileInput from "CustomFileInput";
import documentsService from "@/services/documents";
import alert from "@/mixin/alert.mixin";
import peiAssistantsNeeds from "@/utils/constants/pei/peiAssistantsNeeds";
import Error from "@/components/common/Error";
import peiSaee10Forms from '@/utils/constants/pei/peiSaee10Forms';
import peiStatus from '@/utils/constants/pei/peiStatus';

const Questions = {
  DoesStudentHasColonostomy: 5
};
export default {
  name: "QuestionColonostomy",
  mixins: [alert],
  components: {
    ActionButton,
    CustomTextArea,
    BoxIconButton,
    CustomFileInput,
    Error
  },
  props: {
    peiId:{
      type: String,
      default: () => "",
    },
    isReadonly: {
      type: Boolean,
      default: () => false,
    },
    removeColHeader:{
      type: Boolean,
      default: false
    },
    validate: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      questions: [],
      isAddDocumentMode: false
    };
  },
  computed: {
    selectedPeiId() {
      return store.getters.SelectedPei;
    },
    questionsList() {
      return this.questions;
    },
    studentHasColonostomy() {
      return questionItem =>
        questionItem.id === Questions.DoesStudentHasColonostomy &&
        questionItem.submittedAnswerTypeId === AnswerType.Yes;
    },
    displayDocumentName() {
      return questionItem =>
        questionItem.documentModel?.name ||
        questionItem.submittedDocument?.filename;
    },
    documentAttachmentId() {
      return questionItem => {
        if (questionItem.documentModel) {
          return null;
        }
        return questionItem.submittedDocument?.documentId;
      };
    },
    isDraft() {
      return store.getters.SelectedPeiStatus == peiStatus.Borrador;
    },  
  },
  async mounted() {
    if (!this.questions?.length) {
      await this.getQuestions();
    }
  },
  methods: {
    async getQuestions() {
      const _questions = await needsService.getQuestions({
        peiId: this.selectedPeiId??this.peiId,
        peiCodeId: peiAssistantsNeeds.colonostomia
      });
      this.questions = _questions.map(questionItem => ({
        ...questionItem,
        documentModel: null,
        uploadDocumentPanel: !!questionItem?.submittedDocument?.documentId,
        possibleAnswers: questionItem.possibleAnswers.filter(item =>
          [AnswerType.Yes, AnswerType.No].includes(item.id)
        )
      }));
    },
    onAddClickHandler(questionItem) {
      const currentQuestion = this.questions.find(x => x.id === questionItem.id);

      if (currentQuestion) {
        currentQuestion.uploadDocumentPanel = true;
      }
    },
    updateSelectedAnswer(questionId, answerId) {
      const currentQuestion = this.questions.find(x => x.id === questionId);
      
      if (!currentQuestion?.id) return;

      currentQuestion.submittedAnswerTypeId = answerId;

      if (!this.studentHasColonostomy(currentQuestion)) {
        currentQuestion.documentModel = null;
      }
    },
    onUploadFile(questionId, value) {
      const questionItem = this.questions.find(x => x.id === questionId);
      questionItem.documentModel = value;
      questionItem.submittedDocument = null;
    },
    async onDownloadDocument(documentId) {
      await documentsService.downloadFromServer(documentId);
    },
    async onSaveQuestions() {
      const payload = this.questionsList.map(questionItem => ({
        id: questionItem.submittedId,
        peiId: this.selectedPeiId,
        questionServiceNeedId: questionItem.id,
        answerTypeId: questionItem.submittedAnswerTypeId,
        document: questionItem.documentModel,
        comment: null
      }));

      const justified = this.questionsList.some(questionItem =>
        this.studentHasColonostomy(questionItem)
      );

      this.$emit("save-questions", {
        answers: payload,
        isJustified: justified
      });
    },
    async downloadMedicalReferral(){
      await documentsService.getDocumentByDocumentType(peiSaee10Forms.Saee10b,"pdf");
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/variables/_colors.scss";

.question-container {
  display: flex;
  flex-direction: column;
  gap: 30px;
  padding: 20px 36px;
}
.question-item {
  gap: 30px;
}
.question-box-content {
  border-bottom: solid 1px map-get($colors, "gray-5");
}
.custom-radio-container {
  padding-top: 15px;
}
.custom-radio-button {
  width: 60px;
  height: 60px;
  margin-left: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.custom-radio-button,
.radio-label {
  cursor: pointer;
}
.show-check {
  opacity: 1 !important;
}
.step-label {
  display: block;
  font-family: Lato;
  font-weight: 500;
  line-height: 160%;
}

.cr.rounded-circle.cr-inactive {
  border-color: map-get($colors, "gray-8");
}
.cr.rounded-circle.cr-active {
  border-color: map-get($colors, "white");
}
.cr-error {
  border-color: map-get($colors, "red");
}
.box-icon-button {
  padding: 27px 174px;
}
.field-label {
  font-size: 14px;
  font-weight: 600;
  line-height: 120%;
  letter-spacing: -0.07px;
}
.field-value {
  font-size: 16px;
  font-weight: 500;
  line-height: 140%;
}
/************* custom radio *****************/
.checkbox label:after,
.radio label:after {
  content: "";
  display: table;
  clear: both;
}

.checkbox .cr,
.radio .cr {
  position: relative;
  display: inline-block;
  border: 2px solid map-get($colors, "white");
  width: 1.2em;
  height: 1.2em;
  margin-top: 4px;
}

.checkbox .cr .cr-icon,
.radio .cr .cr-icon {
  position: absolute;
  font-size: 0.6em;
  line-height: 0;
  top: 50%;
  left: 20%;
}

.cr-icon {
  margin-top: 0.04em;
}

.checkbox label input[type="checkbox"],
.radio label input[type="radio"] {
  display: none;
}

.checkbox label input[type="checkbox"] + .cr > .cr-icon,
.radio label input[type="radio"] + .cr > .cr-icon {
  opacity: 0;
}

.checkbox label input[type="checkbox"]:checked + .cr > .cr-icon,
.radio label input[type="radio"]:checked + .cr > .cr-icon {
  opacity: 1;
}

.checkbox label input[type="checkbox"]:disabled + .cr,
.radio label input[type="radio"]:disabled + .cr {
  opacity: 0.5;
}
/************* end of custom radio *****************/

.col:nth-child(4) {
  order: 0; /* Esta propiedad coloca el cuarto elemento antes del primer elemento visualmente */
  flex-basis: 100%; /* Esto hace que ocupe toda la línea */
}
</style>
